import { isUndefined } from 'lodash-es';

import type {
  ConvertibleUnit,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import { useAnnotationsAxisConfig } from './useAnnotationsAxisConfig.js';
import { Formatter } from '../../../../core/types/formatter.js';
import { isNumericalAxis } from '../types/annotations-x-axis-props.js';

export const useAxisFormatter = ():
  | Formatter
  | FormatOptions<Unit, ConvertibleUnit>
  | undefined => {
  const axisConfig = useAnnotationsAxisConfig();

  if (axisConfig && isNumericalAxis(axisConfig)) {
    const { formatter: formatterOptions, unit } = axisConfig;

    if (isUndefined(formatterOptions) && !isUndefined(unit)) {
      return (value: number) => `${value} ${unit}`;
    }

    return formatterOptions;
  }
  return undefined;
};
